import React, { Component, useState, Fragment } from "react";
import { Modal, Button } from "react-bootstrap";
import 'bootstrap/dist/css/bootstrap.min.css';
import Switch from 'react-bootstrap/Switch';

import Cookies from 'js-cookie'

import {addHeaderFunction} from './js/HeaderFunction';
import {addBoardFunction} from './js/BoardFunction';
import {addTeigiFunction} from './js/TeigiFunction';
import StaffTonyaModal from './js/StaffTonyaModal';
import settings from '../assets/settings.json';

import './css/header.css';

export default class Header extends Component{
  state={
    howmany_tehai_taihsou: 0,
		staff_name:'',
		staff_token:'',
		staff_tonya_array:[],
		howmany_staff_tonya:0,
		when_inventory_data:'',
		how_to_import_inventory:null,
		press_start_inventory_button:false
  }
  
  constructor(props) {
    super(props);
  }
  
  componentDidMount () {
    //fetch(`https://api.hello-remix.com/check_updated_at/?token=bb7773835859debab60572f21dbaf133c09ef6d16d970aa8ac921038946e7b3a&name=%E5%A4%A7%E5%B3%B6&type=inventory&val=updated_at`)
    //  .then(res => res.json())
    //  .then(json => console.log('OK'));

		let staff_name = Cookies.get('_replace_staff');
		this.setState({staff_name:staff_name});

		let staff_token = Cookies.get('_replace_token');
		let auth_obj = {"name":staff_name, "token":staff_token};

		let tonya_list = addHeaderFunction.getTonyaList(auth_obj, 'own', this.props);
		this.props.getTonyaDatas(tonya_list);
		let id_array = [];
		for (let i = 0; i < tonya_list.length; i++) {
			id_array.push(tonya_list[i].id);
		}
		this.props.getTonyaDatasIdFix(id_array);
		let when_inventory_data = addHeaderFunction.checkWhenUpdateAt(auth_obj, 'inventory', 'updated_at');

		this.setState({staff_tonya_array:tonya_list});
		this.setState({howmany_staff_tonya:tonya_list.length});
		
		//console.dir(when_inventory_data);
		this.setState({when_inventory_data:when_inventory_data});

		if(when_inventory_data.indexOf('取り込み中') !== -1){
			this.props.isitNowDataImporting(true);
			alert('在庫データ等取り込み中なため、発注終わりのチェック、出荷確認のチェックできません。\nしばらくしてページ更新してみてください.');
		}


		
		//stream
    //const url_tonya_hattyuu_date_stream = 'http://127.0.0.1:8000/hattyuu_owari_data_stream/?name=%E5%A4%A7%E5%B3%B6&token=64980c37d0c56b7cbe5b4f2465b9208e6104fca55a0223f4cd65ba83ece2217f&this_id=1';
    //const url_tonya_hattyuu_date_stream = 'http://127.0.0.1:8000/hattyuu_owari_data_stream/?name=%E5%A4%A7%E5%B3%B6&token=64980c37d0c56b7cbe5b4f2465b9208e6104fca55a0223f4cd65ba83ece2217f';
		
    const url_tonya_hattyuu_date_stream = settings.API_BASE_URL+'hattyuu_owari_data_stream/?name='+staff_name+'&token='+staff_token;
		this.eventSource = new EventSource(url_tonya_hattyuu_date_stream);
    this.eventSource.addEventListener('message', this.handleMessage);


    let settings_list = addTeigiFunction.getSettingsList(staff_token, staff_name);
    {settings_list.map((row, index)=>{
      if(row['key_data']==='isit_auto_import_data'){
        if(row['val_data']==='auto'){
          this.setState({how_to_import_inventory:'自動'});
        }else{
          this.setState({how_to_import_inventory:'手動'});
        }
      }
    })}
		
		
		
		console.log('did mount Header');

  }

	componentWillUnmount() {
    this.eventSource.close();
  }

	handleMessage = async (event) => {
    //console.dir(event.data);
		let res_array = event.data.split('____');
		//console.log('how tonya '+String(res_array.length));

		let this_id = '';		
		let obj_id = '';
		for (let i = 0; i < res_array.length; i++) {
			let row_array = res_array[i].split('___');
			this_id = Number(row_array[0]);
			for (let i = 0; i < this.props.data.tonya_datas.length; i++) {
				obj_id = Number(this.props.data.tonya_datas[i].id);
				if(obj_id===this_id){
					this.props.data.tonya_datas[i].hattyuu_checker = row_array[18];
					this.props.data.tonya_datas[i].hattyuu_owari_who = row_array[16];
					//this.props.data.tonya_datas[i].hattyuu_zan = row_array[21];

					this.props.data.tonya_datas[i].shipment_checker = row_array[17];
					this.props.data.tonya_datas[i].ship_check_owari_who = row_array[15];
				}
			}
		}
		//console.dir(this.props.data.tonya_datas);
		this.props.getTonyaDatas(this.props.data.tonya_datas);

		/*
		let res_array = event.data.split(',');
		let change_id = Number(res_array[0]);
		let change_date = res_array[1];
		let change_who = res_array[2];
		console.dir(this.props.data.tonya_datas);
		for (let i = 0; i < this.props.data.tonya_datas.length; i++) {
			let this_id = this.props.data.tonya_datas[i].id;
			if(change_id===this_id){
				this.props.data.tonya_datas[i].hattyuu_checker =change_date;
				this.props.data.tonya_datas[i].hattyuu_owari_who = change_who;
				this.props.getTonyaDatas(this.props.data.tonya_datas);
			}
		}
		*/
  }

  

  onChanegeStaffTonya(args){
		console.dir(args);
		this.setState({howmany_staff_tonya:args});
  }

	clickOpenMenu = async (e) => {
		this.props.clickMenu(true);
	}

	clickRefreshInventory = async (e) => {
		let alert_box = window.confirm('在庫データ取り込みを始めていいですか？\n各問屋さんのチェック機能は無効化されます。');
		if(alert_box===false){
			e.target.checked = false;
			return 'check_false';
		}

		let _res = addHeaderFunction.start_import_inventory(this.props.data);
		console.dir(_res);

		this.props.isitNowDataImporting(true);
		this.setState({when_inventory_data:'手動取り込み開始しました'});

		if(_res==='ok'){
			alert('毎時 15分に在庫データ取り込みチェックしています。\n次の 15分の時に取り込み開始されます.');
		}
	}

	/*
	clickEnd = async (e) => {
		let alert_box = window.confirm('発注Appを終了します\nよろしいですか？');
		if(alert_box===false){
			e.target.checked = false;
			return 'check_false';
		}

		window.open("about:blank", "_self");
		window.close();
	}
	*/
  
  
  render(){
    return (
      <header className="container my-2 mb-3">
				<div className="row small align-item-center">
					<div className="col-1 logo-area" ><a href="/cm-list"><img className="top-logo" src={"./images/logo192.jpg"} /></a></div>
					<div className="col-2"></div>
					<div className="col-8 inventory-data-info text-right">在庫データ取込日時：{this.state.when_inventory_data}　　在庫取込モード:
						{this.state.how_to_import_inventory==='手動' ? 
							<span className="fw-bold">
								{this.state.how_to_import_inventory}
								{
									this.state.press_start_inventory_button===false && this.props.data.isit_now_data_importing===false ? 
										<button className="btn btn-outline-danger btn-sm start_inventory_button mx-2" onClick={this.clickRefreshInventory} >在庫更新する</button>
										: 
										<button className="btn btn-outline-danger btn-sm start_inventory_button mx-2" disabled>在庫更新する</button>

								}
							</span> 
							: 
							<>{this.state.how_to_import_inventory}</>
						}
						　　未発注数：{this.props.data.howmany_order_fix}　　担当：{this.state.staff_name}</div>
					{/*
					<div className="col-1 cm-data-info">受注件数：{this.props.data.howmany_order_fix}　担当：{this.state.staff_name}</div>
					
					<div className="col-1 staff-data-info">担当：{this.state.staff_name}</div>
					
					<div className="staff-order-tonya-list">
						担当問屋：{this.state.howmany_staff_tonya}
						<StaffTonyaModal
							changeStaffTonya={this.onChanegeStaffTonya.bind(this)} 
							data={this.state} 
						/>
					</div>
					<div className="csv-content">発注済：0</div>
					*/}

					{this.props.data.adamin_member.includes(this.props.data.auth_obj.name) ?
						<>
							<div className="col-1 " >
								<i className="bi bi-download mx-3 click-pointer-elem" onClick={this.clickOpenMenu}></i>
								<a href="/cm-list-teigi"><i className="bi bi-gear"></i></a>
							</div>
						</>
						:
						<>
							<>
								<div className="col-1 " >
									<i className="bi bi-download mx-3 click-pointer-elem" onClick={this.clickOpenMenu}></i>
									<a href="/cm-list-settings"><i className="bi bi-gear"></i></a>
								</div>
							</>
						
						</>
					}

					
					{/* <button className="btn btn-sm btn-outline-info a-small end-button" onClick={this.clickEnd} >終了</button> */}
				</div>

      </header>
    );
  }
}